import { Button, Result } from 'antd';
import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';

const ResetCodeSent: FC = () => {
  const { replace } = useHistory();
  const onClick = () => replace('/auth/login');

  return (
    <Result
      status="success"
      title="An email with the instructions of how to reset your password was sent to your email address"
      subTitle="If you didn't receive the email make sure you have MyHealthyWallet account"
      extra={[
        <Button size="large" type="primary" key="login" onClick={onClick}>
          Back to Login Page
        </Button>,
      ]}
    />
  );
};

export default ResetCodeSent;
